import Ajv from 'ajv';
import { z } from 'zod';

import { axiomValidationOptions } from './options';

export const TeamSchema = z.object({
  id: z.string().uuid(),
  name: z.string().max(255),
});

export type Team = z.infer<typeof TeamSchema>;

const ajv = new Ajv(axiomValidationOptions());

const teamValidation = {
  type: 'object',
  additionalProperties: false,
  properties: {
    name: { type: 'string' },
  },
  required: ['name'],
};

export const teamValidator = ajv.compile(teamValidation);
